import React from "react";
import { format, parseISO } from "date-fns";
import VND from "../../../../components/VND";
import L from "../../../../components/Lang";
import { usePrimaryColor } from "../../../../components/PrimaryColorContext";


/**
 * Renders the list of unpaid bills for a student with checkboxes to include/exclude each bill.
 * @date 2026-04-15
 * @version 2.0
 * @author Forge, opencode + glm-5
 */
export default function BillsToBePaid(props) {
  const { primaryColor } = usePrimaryColor();
  let { student, payment, setPayment } = props;
  let datesArray = [...new Set(student.unpaidBills.map((b) => b.date))];

  return (
    <div>
      {datesArray.map((dates) => (
        <div key={dates}>
          <div className="text-[11px] font-bold text-slate-500">
            {format(parseISO(dates), "dd/MM/yyyy")}
          </div>
          {student.unpaidBills
            .filter((b) => b.date === dates)
            .map((bill) => (
              <div
                key={bill._id}
                className="flex justify-between items-center text-xs mr-3"
                style={{
                  color: !payment.excludedBills.includes(bill._id)
                    ? "#1e293b"
                    : "#94a3b8",
                }}
              >
                <div className="flex items-center gap-1">
                  <input
                    type="checkbox"
                    checked={!payment.excludedBills.includes(bill._id)}
                    onChange={(e) => billCheck(e, bill, payment, setPayment)}
                    className={`h-3.5 w-3.5 rounded border-slate-300 text-${primaryColor}-800 focus:ring-${primaryColor}-800 cursor-pointer accent-${primaryColor}-800`}
                  />
                  <div>{bill.description}</div>
                </div>
                <div>
                  <VND value={bill.amount} />
                </div>
              </div>
            ))}
        </div>
      ))}
      <hr className="border-slate-200 my-1" />
      <div className="flex justify-between text-xs mr-3 font-bold">
        <div>
          <L w="total" />
        </div>
        <div>
          <VND value={student.unpaidBills.reduce((a, b) => a + b.amount, 0)} />
        </div>
      </div>
    </div>
  );
}

function billCheck(e, bill, payment, setPayment) {
  if (e.target.checked) {
    let excludedBills = payment.excludedBills.filter((b) => b !== bill._id);
    let amount = recalcBills({ ...payment, excludedBills });
    setPayment((prev) => ({ ...prev, amount, excludedBills }));
    return;
  }
  let excludedBills = [...payment.excludedBills, bill._id];
  let amount = recalcBills({ ...payment, excludedBills });
  setPayment((prev) => ({ ...prev, amount, excludedBills }));
}

function recalcBills(payment) {
  let amount = 0;
  payment.students
    .filter((student) => !payment.excludedStudents.includes(student._id))
    .forEach((student) => {
      amount += student.unpaidBills
        .filter((bill) => !payment.excludedBills.includes(bill._id))
        .reduce((a, b) => a + b.amount, 0);
    });
  return amount;
}